import { render } from "./ModalPopUp.vue?vue&type=template&id=23c245e1"
import script from "./ModalPopUp.vue?vue&type=script&lang=js"
export * from "./ModalPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__